import LoadingFallback from "@/components/shared/LoadingFallback"

const TestApp = () => {
  return (
    <>
      <LoadingFallback />
    </>
  )
}

export default TestApp